import { ApplicationRef, Component } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { NavigationService } from '../services/navigation.service';
import { routerTransition } from './shared/animations';

@UntilDestroy()
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    animations: [routerTransition]
})
export class AppComponent {

    constructor(
        private _updates: SwUpdate,
        private _navigationService: NavigationService,
        private _appRef: ApplicationRef
    ) {
        this.updateClient();
        // this.checkUpdate(); // try disable see how, if needed then re-enable it

        //   router.events.pipe(untilDestroyed(this)).subscribe( (event: Event) => {

        //     if (event instanceof NavigationEnd) {
        //       let scrollToTop = window.setInterval(() => {
        //         let pos = window.pageYOffset;
        //         if (pos > 0) {
        //           window.scrollTo(0, pos - 20); // how far to scroll on each step
        //         } else {
        //           window.clearInterval(scrollToTop);
        //         }
        //       }, 16);
        //     }

        // });
    }

    getDepth(outlet: any) {
        return outlet.activatedRouteData['depth'];
    }

    getRouteAnimation() {
        return this._navigationService.animationValue;
    }

    updateClient() {

        if (!this._updates.isEnabled) {
            return;
        }

        this._updates.available.pipe(untilDestroyed(this)).subscribe(() => {
            if (confirm("Updates are available, please reload to get updates")) {
                this._updates.activateUpdate().then(() => location.reload());
            }
        });
    }

    // will hit infinite loop issue, temporary disable
    // checkUpdate() {
    //     this._appRef.isStable.pipe(untilDestroyed(this)).subscribe(isStable => {
    //         if (isStable) {
    //             const timeInterval = interval(10 * 60 * 60 * 1000); // 10 hours

    //             timeInterval.pipe(untilDestroyed(this)).subscribe(() => {
    //                 this._updates.checkForUpdate().then(() => {
    //                     this.updateClient();
    //                 });
    //             });
    //         }
    //     });
    // }
}


